export const CATEGORY_SET_ROUTES = 'CATEGORY_SET_ROUTES';
